


















import { Component, Mixins } from 'vue-property-decorator';
import { Popup } from 'vant';
import Dialog from '@/mixins/Dialog';
import Box from '@/components/Box.vue';

@Component({
    components: {
        'van-popup': Popup,
        'box': Box
    }
})
export default class AnswerFailDialog extends Mixins(Dialog) {

    //再来一次
    public onAgainBtn(): void {
        this.$emit("again");
        this.close()
    }

    //关闭弹窗
    public closeDialog(): void {
        this.$emit("close");
        this.show = false;
    }
}
